import { Component, Input, OnInit } from '@angular/core';
import { STORE_LINKS, Storefront } from '../../constants/store-links';

@Component({
  selector: 'app-download',
  templateUrl: './download.component.html',
  styleUrl: './download.component.scss'
})
export class DownloadComponent implements OnInit {
  @Input() giPantMode: boolean = false;
  @Input() henterPantMode: boolean = false;

  private readonly storeLinks = STORE_LINKS;

  constructor() {
  }

  ngOnInit(): void {
  }

  get appleStoreLink(): string {
    return this.storeLinks[this.currentStorefront].appStore;
  }

  get googlePlayLink(): string {
    return this.storeLinks[this.currentStorefront].googlePlay;
  }

  private get currentStorefront(): Storefront {
    if (this.henterPantMode) {
      return 'HENTERPANT';
    }

    return 'GIPANT';
  }
}
